import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const RENDER_WIDTH = 1280;
const MARGIN_MM = 8;

const pickEnd = (start, maxEnd, breaks, minSlice) => {
  const fits = breaks.filter((b) => b > start + minSlice && b <= maxEnd);
  return fits.length ? fits[fits.length - 1] : maxEnd;
};

export async function exportElementToPdf(elementId, filename) {
  let breaksCss = [];
  const canvas = await html2canvas(document.getElementById(elementId), {
    scale: 2,
    backgroundColor: "#fafafa",
    useCORS: true,
    windowWidth: RENDER_WIDTH,
    onclone: (doc) => {
      const el = doc.getElementById(elementId);
      el.style.width = `${RENDER_WIDTH - 80}px`;
      el.style.margin = "0";
      el.style.padding = "24px";
      const top = el.getBoundingClientRect().top;
      const blocks = el.querySelectorAll(":scope > *, :scope > * > *:not(:first-child)");
      breaksCss = [...blocks].map((b) => b.getBoundingClientRect().top - top - 8).filter((v) => v > 0);
    },
  });

  const pdf = new jsPDF("p", "mm", "a4");
  const pageW = pdf.internal.pageSize.getWidth() - MARGIN_MM * 2;
  const pageH = pdf.internal.pageSize.getHeight() - MARGIN_MM * 2;
  const pxPerMm = canvas.width / pageW;
  const pagePx = Math.floor(pageH * pxPerMm);
  const ratio = canvas.width / (RENDER_WIDTH - 80);
  const breaks = [...new Set(breaksCss.map((b) => Math.round(b * ratio)))].sort((a, b) => a - b);

  let start = 0;
  let first = true;
  while (start < canvas.height) {
    const maxEnd = Math.min(start + pagePx, canvas.height);
    const end = maxEnd === canvas.height ? maxEnd : pickEnd(start, maxEnd, breaks, pagePx * 0.35);
    const slice = document.createElement("canvas");
    slice.width = canvas.width;
    slice.height = end - start;
    const ctx = slice.getContext("2d");
    ctx.fillStyle = "#fafafa";
    ctx.fillRect(0, 0, slice.width, slice.height);
    ctx.drawImage(canvas, 0, start, canvas.width, end - start, 0, 0, canvas.width, end - start);
    if (!first) pdf.addPage();
    pdf.addImage(slice.toDataURL("image/jpeg", 0.92), "JPEG", MARGIN_MM, MARGIN_MM, pageW, (end - start) / pxPerMm);
    first = false;
    start = end;
  }
  pdf.save(filename);
}
